import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//            Отправить запрос на добавление/удаление канала
//------------------------------------------------------------------------------
export const postChangeChannels = async ({ object_id, content_type, slug }) => {
  const url = `${backendUrl}/api/alpha/channels/${ slug }/`;
  const data = { object_id, content_type };
  const options = {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  };
  try{
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при изменении списка каналов поста: HTTP error! Status: ${ response.status }`);
    }
    return response;
  } catch(error){
    console.error('Ошибка изменения списка каналов поста:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx